import { useContext, useEffect } from "react";

import { ValidatorFileContext } from "./useFile";
import { useSampleFileLoader } from "./useSampleFileLoader";
import { endpointStore } from "../utils/mobx/EndpointStore";

export const useInitialSample = () => {
  const { files, selectedFileIndex, setFiles, setSelectedFileIndex } =
    useContext(ValidatorFileContext);
  const { endpointType } = endpointStore;
  const { getSamples, getFirstSampleGroupedByIndustry, selectSampleFile } =
    useSampleFileLoader();

  useEffect(() => {
    const loadInitialSample = async () => {
      // 이미 선택된 파일이 있으면 스킵
      if (selectedFileIndex !== -1) return;

      // 첫 번째 industry type의 첫 번째 sample 찾기
      const firstSample = getFirstSampleGroupedByIndustry(endpointType);
      if (!firstSample) return;

      selectSampleFile({
        sample: firstSample,
        endpointType,
        files: files,
        actions: { setFiles, setSelectedFileIndex },
      });
    };

    loadInitialSample();
  }, [
    endpointType,
    getSamples,
    selectedFileIndex,
    setFiles,
    setSelectedFileIndex,
  ]);
};
